import { render, staticRenderFns } from "./CardRegion.vue?vue&type=template&id=e0f883ea&scoped=true&"
import script from "./CardRegion.vue?vue&type=script&lang=js&"
export * from "./CardRegion.vue?vue&type=script&lang=js&"
import style0 from "./CardRegion.vue?vue&type=style&index=0&id=e0f883ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f883ea",
  null
  
)

export default component.exports